import { Chip } from '@mui/material';

const colorMap = {
  active: 'success',
  trial: 'info',
  suspended: 'warning',
  inactive: 'default',
  past_due: 'error',
  cancelled: 'default',
  revoked: 'error',
  rotated: 'warning',
};

export default function StatusChip({ status, label }) {
  const text = label || status?.replace(/_/g, ' ') || 'unknown';
  return (
    <Chip
      size="small"
      label={text.charAt(0).toUpperCase() + text.slice(1)}
      color={colorMap[status] || 'default'}
      variant="outlined"
    />
  );
}
